import { render } from "./10Cooperation.vue?vue&type=template&id=446ca792&scoped=true"
import script from "./10Cooperation.vue?vue&type=script&lang=js"
export * from "./10Cooperation.vue?vue&type=script&lang=js"

import "./10Cooperation.vue?vue&type=style&index=0&id=446ca792&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446ca792"]])

export default __exports__